import { Component, OnInit } from '@angular/core';
import { SignOutViewModel } from './sign-out-view-model';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
  providers: [SignOutViewModel]
})
export class SignOutComponent implements OnInit {
  // A full sign-out page is needed to maintain the functionality of the abandon changes selection modal to allow the
  // user to decide if they want to abandon their changes or not
  constructor(public viewModel: SignOutViewModel) {}

  public ngOnInit(): void {
    this.viewModel.signOut();
  }
}
